/**
 * @constant
 */
const NotificationTypes = {
    PLACE: "Place", // deprecated
    NO_INSEMINATION: "NoInsemination", // deprecated
    TOO_FAST_BIRTH: "TooFastBirth", // deprecated
    SEPARATION_WRONG_AMOUNT: "SeparationWrongAmount", // deprecated
    TOO_FAST_INSEMINATION: "TooFastInsemination", // deprecated
    DEVICE_ALARM: "DeviceAlarm", // deprecated
    ANIMAL: "Animal", // deprecated
    BIRTH_NO_PREGNANCY: "BirthNoPregnancy", // deprecated
    BIRTH_NEGATIVE_USG: "BirthNegativeUSG", // deprecated
    MOMMY_WRONG_AMOUNT: "MommyWrongAmount", // deprecated
    TREATMENT: "Treatment",
    AUTO_CREATE_ANIMAL: "AutoCreateAnimal",
    INSEMINATION_TOO_FAST: "InseminationTooFast",
    FALL_PIGLETS_WRONG_AMOUNT: "FallPigletsWrongAmount",
    NO_PREGNANCY_NO_INSEMINATION: "NoPregnancyNoInsemination",
    PARTURITION_NO_INSEMINATION: "ParturitionNoInsemination",
    PARTURITION_NO_PREGNANCY: "ParturitionNoPregnancy",
    PARTURITION_NEGATIVE_USG: "ParturitionNegativeUSG",
    PARTURITION_TOO_FAST: "ParturitionTooFast",
    USG_NO_INSEMINATION: "USGNoInsemination",
    REPORT_GENERATED: "RaportGenerated",
    FIRST_MILK: "FirstMilk"
};

module.exports = NotificationTypes;
